import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

import type { IRequestTransferReportPayload } from '@app/dashboard/types/innerLayout/balance_and_transfers/single-transfer';

export const getSingleTransferDetails = (id: string, signal?: AbortSignal) => {
  return axiosPrivate.get(`/dashboard/v2/transfers/${id}/detail`, { signal });
};

export const downloadProofOfTransfer = (url: string) => {
  return axiosPrivate.get(url, {
    responseType: 'blob',
  });
};

export const exportSingleTransferReport = ({
  id,
  reportType,
  startDate,
  endDate,
  fileFormat,
  templateType,
}: IRequestTransferReportPayload) => {
  return axiosPrivate.post(`/dashboard/v1/export/report-extended`, {
    transfer_pk: id,
    report_type: reportType,
    start_date: startDate,
    end_date: endDate,
    file_format: fileFormat,
    template: templateType,
  });
};
